import { t } from '@sm/intl';

import { PACKAGE_IDS } from '~pricing/lib/constants';
import { CTA_LABEL } from '~pricing/lib/summaryPackages';

import COPY from './copy';

const CHECKOUT_LINK = '/billing/checkout/?package_id=';
const SIGN_UP_LINK = '/user/sign-up';
const ENTERPRISE_LINK = '/mp/contact-sales/';

type GetCTATextOptions = {
  packageId: number;
  ctaLabel: keyof typeof CTA_LABEL;
};

type CTATextOptions = {
  url?: string;
  text?: string | null;
  disabled?: boolean;
};

export default function getCTAText({ packageId, ctaLabel }: GetCTATextOptions): CTATextOptions {
  // special case handling for Enterprise
  // TODO: add encrypted `sm` parameter to signup link
  if (packageId === PACKAGE_IDS.ENT_PLATINUM) {
    return {
      url: ENTERPRISE_LINK,
      text: t(COPY.CONTACT_US),
    };
  }
  if (ctaLabel === CTA_LABEL.SIGN_UP) {
    return {
      url: SIGN_UP_LINK,
      text: t(COPY.SIGN_UP),
    };
  }
  if (ctaLabel === CTA_LABEL.SELECT) {
    return {
      url: `${CHECKOUT_LINK}${packageId}`,
      text: t(COPY.SELECT),
    };
  }
  if (ctaLabel === CTA_LABEL.NOT_UPGRADEABLE) {
    return {
      url: '',
      text: null,
      disabled: true,
    };
  }
  return {
    url: '',
    text: t(COPY.YOUR_PLAN),
    disabled: true,
  };
}
